<!-- src/views/About.vue -->
<template>
  <div>
    <h2>About Page</h2>
    <p>This is the about page.</p>
  </div>
</template>